import { render } from "./TokenTable.vue?vue&type=template&id=12ef1b52"
import script from "./TokenTable.vue?vue&type=script&lang=js"
export * from "./TokenTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__